import { createApi } from '@reduxjs/toolkit/query/react';
import { HttpMethod } from '@vision/ui/enums';
import { createHttpExtraOptions } from '@vision/ui/utils/http.utils';
import { axiosBaseQuery } from './base.service';
import type { TableDispatchApiRequestDto } from './table-dispatch.api.types';
import {
  normalizeTableDispatchApiResponse,
  toTableDispatchExportRequestDto,
  toTableDispatchRequestDto,
} from './table-dispatch.service.mapper';
import type {
  TableDispatchApiResponse,
  TableDispatchExportServiceArgs,
  TableDispatchServiceArgs,
} from './table-dispatch.types';

export function buildTableDispatchApiRequest({ async = false, input, widgetId }: TableDispatchServiceArgs) {
  const data: TableDispatchApiRequestDto = {
    ...toTableDispatchRequestDto(input),
    async,
    ...(widgetId && { dashboard_widget_id: widgetId }),
  };

  return {
    data,
    extraOptions: createHttpExtraOptions({
      notification: {
        autoHandleSuccess: false,
      },
    }),
    method: HttpMethod.POST,
    url: '/v2/reporting/campaigns/participation',
  };
}

export function buildTableDispatchExportApiRequest({ input }: TableDispatchExportServiceArgs) {
  return {
    data: toTableDispatchExportRequestDto(input),
    extraOptions: createHttpExtraOptions({
      notification: {
        autoHandleSuccess: true,
        translationMessageKey: 'http.message.reports.exportTableDispatch.{{status}}',
      },
    }),
    method: HttpMethod.POST,
    url: '/v2/reporting/campaigns/participation/export',
  };
}

export const TableDispatchService = createApi({
  reducerPath: 'TableDispatchService',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    createTableDispatch: builder.mutation<TableDispatchApiResponse, TableDispatchServiceArgs>({
      query: buildTableDispatchApiRequest,
      transformResponse: normalizeTableDispatchApiResponse,
    }),
    exportTableDispatch: builder.mutation<Record<string, never>, TableDispatchExportServiceArgs>({
      query: buildTableDispatchExportApiRequest,
    }),
  }),
});

export const { useCreateTableDispatchMutation, useExportTableDispatchMutation } = TableDispatchService;
